"use client";
import {
  useMenuContext
} from "./6UXSIZXV.js";
import {
  useMenubarContext
} from "./5FUUHUOH.js";
import {
  useHovercardStoreProps
} from "./AIV7BRAA.js";
import {
  useCompositeStoreProps
} from "./W6MTWV42.js";
import {
  useComboboxProviderContext
} from "./6C2ASARV.js";
import {
  useStore,
  useStoreProps
} from "./SOQQIDO4.js";
import {
  useUpdateEffect
} from "./W2TDKEPX.js";

// src/menu/menu-store.ts
import * as Core from "@ariakit/core/menu/menu-store";
function useMenuStoreProps(store, update, props) {
  useUpdateEffect(update, [props.combobox, props.parent, props.menubar]);
  useStoreProps(store, props, "values", "setValues");
  return Object.assign(
    useHovercardStoreProps(
      useCompositeStoreProps(store, update, props),
      update,
      props
    ),
    {
      combobox: props.combobox,
      parent: props.parent,
      menubar: props.menubar
    }
  );
}
function useMenuStore(props = {}) {
  const parent = useMenuContext();
  const menubar = useMenubarContext();
  const combobox = useComboboxProviderContext();
  props = {
    ...props,
    parent: props.parent !== void 0 ? props.parent : parent,
    menubar: props.menubar !== void 0 ? props.menubar : menubar,
    combobox: props.combobox !== void 0 ? props.combobox : combobox
  };
  const [store, update] = useStore(Core.createMenuStore, props);
  return useMenuStoreProps(store, update, props);
}

export {
  useMenuStoreProps,
  useMenuStore
};
